import React from 'react';
import { 
  Book, 
  Mail,
  ChevronRight,
  Instagram,
  Youtube,
  Music
} from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Documentation() {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      {/* Introduction */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-12 h-12 rounded-lg bg-indigo-100 dark:bg-indigo-900/50 flex items-center justify-center">
            <Book className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Documentação Kontty
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Guia completo para aproveitar ao máximo nossa plataforma
            </p>
          </div>
        </div>

        <div className="prose dark:prose-invert max-w-none">
          <p>
            Bem-vindo à Kontty! Aqui, você encontrará todas as informações necessárias
            para tirar o máximo proveito da nossa plataforma de gestão de conteúdo.
          </p>
        </div>
      </div>

      {/* Main Features */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
          Funcionalidades Principais
        </h2>

        <div className="space-y-6">
          {/* Dashboard */}
          <div className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
            <div className="flex items-center space-x-3 mb-2">
              <ChevronRight className="h-5 w-5 text-indigo-600 dark:text-indigo-400" />
              <h3 className="font-medium text-gray-900 dark:text-white">Início</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-400 ml-8">
              Na página inicial, você encontra um resumo das suas métricas e atalhos rápidos
              para as principais funcionalidades. Monitore seu desempenho e acesse rapidamente
              a geração de ideias ou análises detalhadas.
            </p>
          </div>

          {/* Content Ideas */}
          <div className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
            <div className="flex items-center space-x-3 mb-2">
              <ChevronRight className="h-5 w-5 text-indigo-600 dark:text-indigo-400" />
              <h3 className="font-medium text-gray-900 dark:text-white">Ideias de Conteúdo</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-400 ml-8">
              Gere ideias personalizadas para seu conteúdo ou crie um plano detalhado
              respondendo algumas perguntas sobre seu objetivo e público-alvo. Nossa IA
              criará sugestões específicas para sua estratégia.
            </p>
          </div>

          {/* Analytics */}
          <div className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
            <div className="flex items-center space-x-3 mb-2">
              <ChevronRight className="h-5 w-5 text-indigo-600 dark:text-indigo-400" />
              <h3 className="font-medium text-gray-900 dark:text-white">Análises</h3>
            </div>
            <div className="ml-8 space-y-4">
              <p className="text-gray-600 dark:text-gray-400">
                Conecte suas redes sociais para acessar métricas detalhadas:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="flex items-center space-x-2">
                  <span className="text-gray-600 dark:text-gray-400">Instagram</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-gray-600 dark:text-gray-400">YouTube</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-gray-600 dark:text-gray-400">TikTok</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Support */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 rounded-lg bg-indigo-100 dark:bg-indigo-900/50 flex items-center justify-center">
            <Mail className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Precisa de Ajuda?
            </h2>
            <p className="text-gray-600 dark:text-gray-400">
              Entre em contato conosco pelo e-mail{' '}
              <a 
                href="mailto:team.novacontent@gmail.com"
                className="text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300"
              >
                team.novacontent@gmail.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}